module.exports = __webpack_public_path__ + "img/cursor.ca7b2bf0.svg";